import { IDocument, IFilters, NoteDTO, amplitude } from 'wisestep-api';

import { ClientNotesWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';

export const getDocumentFromNote = (note: NoteDTO, isAdding: boolean): IDocument[] => {
  if (isAdding) return [];

  return note?.files
    ? note.files.map((file) => ({
        documentLocation: file.location,
        originalName: file.name,
        tag: null,
        uploadedOn: note.createdOn,
      }))
    : [];
};

export const notesAmplitudeEvents = (name: string, clickedOnName: string, workspace) => {
  amplitude(name, {
    clickedOn: clickedOnName,
    workspaceName: workspace.name,
    pageName: 'Notes',
    planType: workspace.planType,
    interfaceType: 'web',
    pageUrl: window.location.href,
  });
};

export interface ListingSearchPropsForNotesListing {
  fromDate: Date | null;
  toDate: Date | null;
  createdBy?: string[];
  clientIds?: string[];
  contactIds?: string[];
  type?: string;
  searchAcross?: string[];
  noteType?: string;
  clientNames?: string[];
}

export const setDefaultSearchFilterNotesListing = (
  query: IFilters
): ListingSearchPropsForNotesListing => {
  return {
    fromDate: query.fromDate ? new Date(query.fromDate) : null,
    toDate: query.toDate ? new Date(query.toDate) : null,
    createdBy: query.createdBy ?? [],
    clientIds: query.clientIds ?? [],
    contactIds: query.contactIds ?? [],
    type: query.type ?? '',
    searchAcross: query.searchAcross ?? [],
    noteType: query.noteType ?? '',
    clientNames: query.clientNames ?? [],
  };
};

export const filterByWidget = (widgetName: ClientNotesWidget): [string, string][] => {
  switch (widgetName) {
    case ClientNotesWidget.METRIC_TOTAL_CLIENT:
      return [['METRIC_TOTAL_CLIENT', 'client']];
    case ClientNotesWidget.METRIC_TOTAL_CLIENT_SPOC:
      return [['METRIC_TOTAL_CLIENT_SPOC', 'client_contact']];
    default:
      return [];
  }
};
